module.exports = __webpack_public_path__ + "static/media/hero-image-desktop@2x.c583d045.jpg";